var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25008 1.3335C3.71878 1.3335 1.66675 3.38554 1.66675 5.91683C1.66675 10.5002 7.08341 14.6668 10.0001 15.6361C12.9167 14.6668 18.3334 10.5002 18.3334 5.91683C18.3334 3.38554 16.2814 1.3335 13.7501 1.3335C12.2 1.3335 10.8295 2.10304 10.0001 3.28091C9.17062 2.10304 7.80021 1.3335 6.25008 1.3335Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.13f16f1a0f0f2de3f73f15d05fe65cc2.svg";
export { ForwardRef as ReactComponent };